module.exports = __webpack_public_path__ + "media/s3Model2.cffd0061.mp4";